import ReactiveState from '@/ui-kit/hooks/ReactiveState';

export interface PaginationDto {
  pageSize: number;
  totalItems: number;
}

export abstract class Pagination<T extends PaginationDto> {
  protected abstract reactiveState: ReactiveState<T>;

  abstract get firstIndexOnPage(): number;

  abstract get lastIndexOnPage(): number;

  abstract setPreviousPage(): void;

  abstract setNextPage(): void;

  get pageSize(): number {
    return this.reactiveState.value.pageSize;
  }

  get totalItems(): number {
    return this.reactiveState.value.totalItems;
  }

  get options(): T {
    return this.reactiveState.value;
  }

  setPageSize(pageSize: number): void {
    this.setOptions({ pageSize } as Partial<T>);
  }

  setOptions(options: Partial<T>): void {
    this.reactiveState.patch(options);
  }
}
